import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid
} from '@mui/material';
import AccountProfileDetails from '../components/account/AccountProfileDetails';
import SettingsPassword from '../components/account/SettingsPassword';

const Account = () => (
  <>
    <Helmet>
      <title>Mon compte | TheScan</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >

      <Container maxWidth="lg">
        <AccountProfileDetails />
        <Box sx={{ pt: 3 }}>
          <SettingsPassword />
        </Box>
      </Container>
    </Box>
  </>
);

export default Account;
